
export const resources = [
    {
        id: 1,
        title: "The Ultimate Guide to Industrial Valves in Sri Lanka",
        slug: "industrial-valves-guide-sri-lanka",
        date: "2024-05-20",
        category: "Valves",
        excerpt: "Everything you need to know about choosing, installing, and maintaining industrial valves for your projects in Sri Lanka.",
        content: "Full content would go here...",
        meta: {
            title: "Industrial Valves Guide Sri Lanka | Types, Usage & Maintenance",
            description: "A comprehensive guide on industrial valves in Sri Lanka. Learn about gate valves, ball valves, check valves, and how to choose the right one for your needs.",
            keywords: "industrial valves Sri Lanka, gate valves Colombo, ball valves guide, valve maintenance, choosing industrial valves"
        }
    },
    {
        id: 2,
        title: "Understanding Steel Grades: MS, GI, and SS Explained",
        slug: "understanding-steel-grades-ms-gi-ss",
        date: "2024-05-15",
        category: "Structural Steel",
        excerpt: "A deep dive into the differences between Mild Steel, Galvanized Iron, and Stainless Steel for construction and industrial use.",
        content: "Full content would go here...",
        meta: {
            title: "Understanding Steel Grades | MS vs GI vs SS Steel Comparison",
            description: "Which steel grade is right for your project? Compare Mild Steel (MS), Galvanized Iron (GI), and Stainless Steel (SS) in this authoritative guide.",
            keywords: "steel grades Sri Lanka, MS vs GI vs SS, industrial steel comparison, structural steel guide, stainless steel vs mild steel"
        }
    },
    {
        id: 3,
        title: "GI Conduit Installation Best Practices",
        slug: "gi-conduit-installation-best-practices",
        date: "2024-05-10",
        category: "Electrical",
        excerpt: "Learn the industry standards for installing GI conduits effectively to ensure safety and longevity in industrial environments.",
        content: "Full content would go here...",
        meta: {
            title: "GI Conduit Installation Guide | Electrical Safety Standards",
            description: "Master the art of GI conduit installation with our expert guide. Cover best practices, fittings, and safety standards for Sri Lankan industrial sites.",
            keywords: "GI conduit installation, electrical conduit guide, industrial wiring Sri Lanka, conduit fittings guide, GI pipe installation"
        }
    },
    {
        id: 4,
        title: "Stainless Steel 304 vs 316: Which is Right for Your Project?",
        slug: "stainless-steel-304-vs-316-comparison",
        date: "2024-05-25",
        category: "Materials",
        excerpt: "Learn the key differences between 304 and 316 stainless steel grades, including corrosion resistance, cost, and typical applications in Sri Lanka.",
        content: "When choosing stainless steel for industrial or construction projects in Sri Lanka, the two most common grades you will encounter are 304 and 316. While they look identical to the naked eye, their chemical composition and performance characteristics differ significantly...\n\nGrade 304: The most versatile and widely used stainless steel. It contains chromium and nickel, providing excellent corrosion resistance for most indoor and general-purpose applications.\n\nGrade 316: Contains an addition of molybdenum, which drastically increases its resistance to chlorides and salt spray. This makes it the superior choice for coastal areas in Sri Lanka, chemical processing plants, and marine environments.",
        meta: {
            title: "Stainless Steel 304 vs 316 | Comparison Guide for Sri Lanka",
            description: "Discover the critical differences between 304 and 316 stainless steel. Which grade should you use for your project in Sri Lanka? Find out here.",
            keywords: "304 vs 316 stainless steel, SS 304 Sri Lanka, SS 316 price Colombo, stainless steel grades comparison, marine grade stainless steel"
        }
    },
    {
        id: 5,
        title: "Best Metal Suppliers in Sri Lanka: How to Choose the Right Partner",
        slug: "best-metal-suppliers-sri-lanka-selection-guide",
        date: "2024-05-28",
        category: "Industry Insights",
        excerpt: "A guide on what to look for when choosing a metal supplier in Sri Lanka, from quality certifications to delivery reliability.",
        content: "Sourcing high-quality metal products is crucial for the success of any construction or industrial project. With many suppliers in Colombo and across Sri Lanka, how do you know which one to trust? Factors like material certification, wholesale pricing, inventory range, and delivery efficiency are key markers of a reliable partner like Real Metro Metal...",
        meta: {
            title: "Best Metal Suppliers in Sri Lanka | How to Choose a Reliable Partner",
            description: "Looking for the best metal suppliers in Sri Lanka? Our guide covers what factors to consider when choosing a wholesale partner for your industrial needs.",
            keywords: "metal suppliers Sri Lanka, best steel suppliers Colombo, wholesale hardware Sri Lanka, reliable metal partner, Real Metro Metal reviews"
        }
    }
];
